import React from "react";
import { useLearner } from "../../contexts/LearnerContext";
import { ResumeCard } from "../../components/dashboard/ResumeCard";
import { TodayPanel } from "../../components/dashboard/TodayPanel";
import { MyWordsPanel } from "../../components/dashboard/MyWordsPanel";
import { CourseList } from "../../components/dashboard/CourseList";
import { WeeklyActivity } from "../../components/dashboard/WeeklyActivity";
import { SkillBalance } from "../../components/dashboard/SkillBalance";
import { EmptyDashboard } from "../../components/dashboard/EmptyDashboard";
function greeting(): string {
  const h = new Date().getHours();
  if (h < 12) return "Buenos días";
  if (h < 20) return "Buenas tardes";
  return "Buenas noches";
}
export function Dashboard() {
  const {
    activeCourse,
    user,
    courses
  } = useLearner();
  if (!activeCourse || courses.length === 0) {
    return <div className="mx-auto max-w-6xl px-4 py-6 md:px-8 md:py-10" data-id="element-1313" data-mp="pk182bml03uj">
        <EmptyDashboard data-id="element-1314" data-mp="pm44pei8ov88" />
      </div>;
  }
  return <div className="mx-auto max-w-6xl px-4 py-6 md:px-8 md:py-10" data-id="element-1315" data-mp="zdxf4fajpfc8">
      <header className="mb-6" data-id="element-1316" data-mp="13eppjbv5lqa3">
        <p className="text-sm font-semibold text-ink-2" data-id="element-1317" data-mp="13frbibdpjx6l">
          {greeting()}, {user.name.split(" ")[0]}
        </p>
        <h1 className="mt-1 text-[28px] font-bold leading-tight tracking-[-0.02em] md:text-4xl" data-id="element-1318" data-mp="18c9cr19txde6">Pick up where you left off</h1>
      </header>

      <div className="grid gap-6 lg:grid-cols-3" data-id="element-1319" data-mp="1i3m31ofzbvi3">
        <div className="lg:col-span-2" data-id="element-1320" data-mp="1i2u7ueqanzsc">
          <ResumeCard course={activeCourse} data-id="element-1321" data-mp="1i5ym64xh4bwq" />
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1" data-id="element-1322" data-mp="1n1dygsfu1zr1">
          <TodayPanel data-id="element-1323" data-mp="1r3saotozy19c" />
          <MyWordsPanel course={activeCourse} data-id="element-1324" data-mp="1r5lmsoidpdoq" />
        </div>

        <div className="lg:col-span-2" data-id="element-1325" data-mp="1w34yphrltedi">
          <CourseList data-id="element-1326" data-mp="1w23kj4fakbrk" />
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1" data-id="element-1327" data-mp="1w10x56h6grge">
          <WeeklyActivity data-id="element-1328" data-mp="3sx86s63us8bp" />
          <SkillBalance course={activeCourse} data-id="element-1329" data-mp="3sy1h1h20tfyl" />
        </div>
      </div>
    </div>;
}